import React, {useCallback, useEffect} from 'react';
import {observer} from 'mobx-react';
import {formsStore} from '../../_legacy/Form/stores/FormsStore';
import {Dialog} from '@priority-software/priority-style-react';
import {InfoContent} from './InfoContent';
import {getServerTexts} from './texts';
import {InfoDialogWidth} from './constants';
import {returnFocus} from '../../_shared/GWTBridge/invoke/genPage';
import {getTopDialogZindex} from '../../_shared/GWTBridge/invoke/priModalDlg';
import styles from './styles.module.scss';
import {getZoomFname} from './utils/utils';
import {getFieldOrigValue, getRelatedFieldValue} from '../../_shared/GWTBridge/invoke/priTextBox';

type MoreInfoProps = {
    docName: string;
};

export const MoreInfo = observer(({docName}: MoreInfoProps) => {
    const {currentForm} = formsStore;
    const isOpen = currentForm?.showMoreInfo;

    const closeInfo = useCallback(() => {
        returnFocus();
        currentForm?.closeFieldMoreInfo();
    }, [currentForm]);

    const storeMoreInfo = useCallback(
        data => {
            currentForm?.setCurrentFieldMoreInfo(data);
        },
        [currentForm]
    );

    useEffect(() => {
        (async () => getServerTexts())();
    }, []);

    if (!isOpen || !currentForm) {
        return null;
    }
    const currentColumn =
        currentForm?.currentCell &&
        currentForm?.columnsMap &&
        currentForm.getColumnByNumber((currentForm.currentCell.gridColumn + 1).toString());

    if (currentColumn) {
        const relatedValue = getRelatedFieldValue();
        const originalValue = getFieldOrigValue();
        const entityType = docName && !currentForm.parentForm ? docName : currentColumn.title;

        return (
            <Dialog
                componentClasses={styles.component}
                size="small"
                draggable
                mask={false}
                closable={false}
                width={InfoDialogWidth}
                isOpen={isOpen}
                zIndex={getTopDialogZindex()}
                content={
                    <InfoContent
                        key={currentForm?.session}
                        storeMoreInfo={storeMoreInfo}
                        formName={currentForm?.name}
                        currentRow={currentForm?.currentCell?.row}
                        currentCell={currentForm?.currentCell?.gridColumn}
                        closeInfo={closeInfo}
                        zoomFname={getZoomFname(currentForm, currentColumn)}
                        zoomName={
                            currentColumn.zoomFname ? currentColumn.name : currentColumn.relColName
                        }
                        fieldName={currentColumn.relColName || currentColumn.name}
                        zoomValue={currentColumn.relColName ? relatedValue : originalValue}
                        entityType={entityType}
                        entityDescription={currentColumn.relColName ? originalValue : relatedValue}
                    />
                }
            />
        );
    }

    return null;
});
